import fc from "@/firebaseConfig";
import firebase from "firebase/app";
const moment = require("moment-timezone");
const Splitter = require("./splitter");
const tambon = require("./data/tambon.json");
const city = require("./data/city.json");
const country = require("./data/country.json");

const { resolveZipCode } = require("../../libs/postcode");

const countryCodeList = [
  {
    alphaCode: "AF",
    countryName: "ประเทศอัฟกานิสถาน"
  },
  {
    alphaCode: "AM",
    countryName: "ประเทศอาร์เมเนีย"
  },
  {
    alphaCode: "AZ",
    countryName: "ประเทศอาเซอร์ไบจาน"
  },
  {
    alphaCode: "BH",
    countryName: "ประเทศบาห์เรน"
  },
  {
    alphaCode: "BD",
    countryName: "ประเทศบังกลาเทศ"
  },
  {
    alphaCode: "BT",
    countryName: "ประเทศภูฏาน"
  },
  {
    alphaCode: "BN",
    countryName: "ประเทศบรูไน"
  },
  {
    alphaCode: "KH",
    countryName: "ประเทศกัมพูชา"
  },
  {
    alphaCode: "CN",
    countryName: "ประเทศจีน"
  },
  {
    alphaCode: "CY",
    countryName: "ประเทศไซปรัส"
  },
  {
    alphaCode: "GE",
    countryName: "ประเทศจอร์เจีย"
  },
  {
    alphaCode: "IN",
    countryName: "ประเทศอินเดีย"
  },
  {
    alphaCode: "ID",
    countryName: "ประเทศอินโดนีเซีย"
  },
  {
    alphaCode: "IR",
    countryName: "ประเทศอิหร่าน"
  },
  {
    alphaCode: "IQ",
    countryName: "ประเทศอิรัก"
  },
  {
    alphaCode: "IL",
    countryName: "ประเทศอิสราเอล"
  },
  {
    alphaCode: "JP",
    countryName: "ประเทศญี่ปุ่น"
  },
  {
    alphaCode: "JO",
    countryName: "ประเทศจอร์แดน"
  },
  {
    alphaCode: "KZ",
    countryName: "ประเทศคาซัคสถาน"
  },
  {
    alphaCode: "KW",
    countryName: "ประเทศคูเวต"
  },
  {
    alphaCode: "KG",
    countryName: "ประเทศคีร์กีซสถาน"
  },
  {
    alphaCode: "LA",
    countryName: "ประเทศลาว"
  },
  {
    alphaCode: "LB",
    countryName: "ประเทศเลบานอน"
  },
  {
    alphaCode: "MY",
    countryName: "ประเทศมาเลเซีย"
  },
  {
    alphaCode: "MV",
    countryName: "ประเทศมัลดีฟส์"
  },
  {
    alphaCode: "MN",
    countryName: "ประเทศมองโกเลีย"
  },
  {
    alphaCode: "MM",
    countryName: "ประเทศพม่า"
  },
  {
    alphaCode: "NP",
    countryName: "ประเทศเนปาล"
  },
  {
    alphaCode: "OM",
    countryName: "ประเทศโอมาน"
  },
  {
    alphaCode: "PK",
    countryName: "ประเทศปากีสถาน"
  },
  {
    alphaCode: "PH",
    countryName: "ประเทศฟิลิปปินส์"
  },
  {
    alphaCode: "QA",
    countryName: "ประเทศกาตาร์"
  },
  {
    alphaCode: "SA",
    countryName: "ประเทศซาอุดีอาระเบีย"
  },
  {
    alphaCode: "SG",
    countryName: "ประเทศสิงคโปร์"
  },
  {
    alphaCode: "KR",
    countryName: "ประเทศเกาหลีใต้"
  },
  {
    alphaCode: "LK",
    countryName: "ประเทศศรีลังกา"
  },
  {
    alphaCode: "SY",
    countryName: "ประเทศซีเรีย"
  },
  {
    alphaCode: "TW",
    countryName: "ประเทศไต้หวัน"
  },
  {
    alphaCode: "TJ",
    countryName: "ประเทศทาจิกิสถาน"
  },
  {
    alphaCode: "TH",
    countryName: "ประเทศประเทศไทย"
  },
  {
    alphaCode: "TR",
    countryName: "ประเทศตุรกี"
  },
  {
    alphaCode: "TM",
    countryName: "ประเทศเติร์กเมนิสถาน"
  },
  {
    alphaCode: "AE",
    countryName: "ประเทศสหรัฐอาหรับเอมิเรตส์"
  },
  {
    alphaCode: "UZ",
    countryName: "ประเทศอุซเบกิสถาน"
  },
  {
    alphaCode: "VN",
    countryName: "ประเทศเวียดนาม"
  },
  {
    alphaCode: "YE",
    countryName: "ประเทศเยเมน"
  },
  {
    alphaCode: "US",
    countryName: "ประเทศสหรัฐอเมริกา"
  },
  {
    alphaCode: "DE",
    countryName: "ประเทศเยอรมนี"
  },
  {
    alphaCode: "CA",
    countryName: "ประเทศแคนาดา"
  },
  {
    alphaCode: "MX",
    countryName: "ประเทศเม็กซิโก"
  },
  {
    alphaCode: "NL",
    countryName: "ประเทศเนเธอร์แลนด์"
  },
  {
    alphaCode: "BR",
    countryName: "ประเทศบราซิล"
  },
  {
    alphaCode: "AU",
    countryName: "ประเทศออสเตรเลีย"
  },
  {
    alphaCode: "RU",
    countryName: "ประเทศรัสเซีย"
  },
  {
    alphaCode: "ZA",
    countryName: "ประเทศแอฟริกาใต้"
  },
  {
    alphaCode: "GB",
    countryName: "ประเทศสหราชอาณาจักร"
  }
];

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async importDocs({ commit }, { docs, companyID }) {
      commit("setLoading", true);
      
      // Initialize tracking
      const importLog = {
        totalRecords: docs.length,
        successCount: 0,
        failureCount: 0,
        successRecords: [],
        failedRecords: [],
        errors: [],
      };
      
      this.isEmpty = function (value) {
        return value === null || typeof value === "undefined"
          ? ""
          : String(value).replace(/\s/g, " ");
      };
      this.isEmptyNum = function (value, companyID, domain) {
        // console.log("domain ==> ", domain)
        if (value === null) {
          commit;
        } else if (typeof value === "undefined") {
          return 0;
        } else {
          // console.log(value, Math.round(value * 1000))
          //pidilite bamco test GoMBP30inwwbyosHZwH3
          //pidilite bamco production XMigdx2tCoT0CD4JDkGN
          if ((companyID == "XMigdx2tCoT0CD4JDkGN" || companyID == "0m2cwidBErAKMf2I9vkT" || companyID == "GoMBP30inwwbyosHZwH3" ) && (domain.trim() != "TH" && domain)) {
            // console.log("Company ==> ", companyID);
            // console.log("Workss");
            // console.log("docCurrency", domain);
            // console.log("companyID", companyID);
            value = Math.round(value * 10000);
          } else {
            value = Math.round(value * 100);
          }
          return value;
        }
      };

      this.getForeignCountryCode = function (domain) {
        if (!domain) return "TH"
      
        if (domain !== "TH") {
          return domain.trim()
        } else {
          return "TH"
        }
      };
      
      this.getForeignCountryNameTH = function (domain) {
        if (!domain) return "ประเทศไทย"
      
        if (domain !== "TH") {
          const res = countryCodeList.find((country) => country.alphaCode === domain.trim())?.countryName
          return res ? res : domain
        } else {
          return "ประเทศไทย"
        }
      }

      this.getTypeCode = function (docType) {
        switch (docType) {
          case 1:
            return "TX";
          case 2:
            return "AB";
          case 3:
            return "DR";
          case 4:
            return "CR";
          case 5:
            return "RE";
          case 6:
            return "RT";
          default:
            return "XX";
        }
      };

      this.getCityCountryCode = function (countyVal, cityVal, blockVal) {
        var countryCode = "";
        var cityCode = "";
        var tambonCode = "";
        try {
          countyVal = countyVal || "";
          countyVal = countyVal.replace("จังหวัด", "");

          countryCode = country[countyVal];
          cityCode = "";
          tambonCode = "";
          if (countryCode) {
            var cityObj = city[countryCode];
            if (cityObj) {
              // Remove "อำเภอ"
              cityVal = cityVal || "";
              cityVal = cityVal.replace("อำเภอ", "");
              cityVal = cityVal.replace("อ.", "");
              cityVal = cityVal.replace(/ +/g, "");
              cityVal = cityVal.trim();

              cityCode = cityObj[cityVal];
              if (!cityCode) {
                cityCode = cityObj["เขต " + cityVal];
              }
              if (!cityCode) {
                cityCode = cityObj["เขต" + cityVal];
              }

              let tambonObj = tambon[cityCode];
              if (tambonObj) {
                blockVal = blockVal || "";
                blockVal = blockVal.replace("แขวง", "");
                blockVal = blockVal.replace("ตำบล", "");
                blockVal = blockVal.replace(/ +/g, "");
                blockVal = blockVal.trim();

                tambonCode = tambonObj[blockVal];
              }
            }
          }
        } catch (e) {
          console.log(e);
        }

        return {
          county: countryCode || "",
          countyName: countyVal || "",
          city: cityCode || "",
          cityName: cityVal || "",
          tambon: tambonCode || "",
          tambonName: blockVal || "",
        };
      };

      this.setDocData = function (doc) {
        // console.log("input doc::::::: ", doc)
        var docData = {
          baseInvoiceAmount: this.isEmptyNum(doc.baseInvoiceAmount),
          docDueDate: doc.docDueDate
            ? moment(doc.docDueDate, "YYYY-MM-DD").isValid()
              ? moment(doc.docDueDate, "YYYY-MM-DD")
                  .tz("Asia/Bangkok")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS+07:00")
              : ""
            : "",
          paymentTermsCode: this.isEmpty(doc.paymentTermsCode),
          customerVendorRef: this.isEmpty(doc.customerVendorRef),
          downPaymentAmount: this.isEmptyNum(doc.downPaymentAmount),
          tel1: this.isEmpty(doc.tel1),
          tel2: this.isEmpty(doc.tel2),
          fax1: this.isEmpty(doc.fax1),
          salesEmployeeName: this.isEmpty(doc.salesEmployeeName),
          contactPersonName: this.isEmpty(doc.contactPersonName),
          baseRefNo: this.isEmpty(doc.baseRefNo),
          baseRefDate: doc.baseRefDate
            ? moment(doc.baseRefDate, "YYYY-MM-DD").isValid()
              ? moment(doc.baseRefDate, "YYYY-MM-DD")
                  .tz("Asia/Bangkok")
                  .format("YYYY-MM-DDTHH:mm:ss.SSS+07:00")
              : ""
            : "",
          crReason1: this.isEmpty(doc.crReason1),
          crReason2: this.isEmpty(doc.crReason2),
          drReason1: this.isEmpty(doc.drReason1),
          drReason2: this.isEmpty(doc.drReason2),
          payBy: this.isEmpty(doc.payBy),
          domain: this.isEmpty(doc.domain),
          allowancePercent: this.isEmptyNum(doc.allowancePercent),
        };
        return docData;
      };

      return fc.companies
        .doc(companyID)
        .get()
        .then(async (companyData) => {
          console.log("=========== Company Id : ", companyID);
          var DocPdfID = "";
          if (companyData) {
            DocPdfID = companyData.data().docPdfID;
            if (DocPdfID == undefined) {
              DocPdfID = "";
            }


            var batch = fc.db.batch();
            // Docs added to the current (not-yet-committed) batch. They are
            // counted as success ONLY after batch.commit() actually succeeds.
            var pendingRecords = [];
            for (var k = 0; k < docs.length; k++) {
              try {
                var doc = docs[k];

                const docID = doc.docID
                const docType = parseInt(doc.docType)
                const typeCode = this.getTypeCode(docType)
                const objectID = docID + '_' + typeCode
                var docData = this.setDocData(doc)
                var fireStoreData = {}
                
                // Validate required fields
                if (!docID || docID.toString().trim() === '') {
                  throw new Error('เลขที่เอกสารไม่ถูกต้องหรือเป็นค่าว่าง');
                }
              //update condition
              var gSchemeID ='';
              const buyerBranchID = doc.buyerBranchID.trim()
              var taxID = doc.buyerTaxID.trim() + buyerBranchID;
              var taxIDlength = taxID.length;
              var btpID = '';

              // if((doc.buyerTaxID.length) == 13 && (doc.buyerBranchID.length) == 5){
              //   gSchemeID = "TXID";
              // }
              // if((doc.buyerTaxID.length) == 13 && doc.buyerBranchID == ""){
              //   gSchemeID = "NIDN";
              // }
              // if((doc.buyerTaxID == "" || doc.buyerTaxID =="N/A") && doc.buyerBranchID == ""){
              //   gSchemeID = "OTHR";
              // }

              if (taxIDlength == 18 && buyerBranchID != "") {
                gSchemeID = "TXID";
                btpID = taxID
              }else if(taxIDlength == 13 && buyerBranchID == "") {
                gSchemeID = "NIDN";
                btpID = taxID
              }else if(taxIDlength == null || taxIDlength == 0 || taxIDlength == "") {
                gSchemeID = "OTHR";
                btpID = "N/A"
              }else if(taxIDlength !== null && taxIDlength > 0 && taxIDlength < 13 && buyerBranchID == "") {
                gSchemeID = "CCPT"
                btpID = taxID
              }
              
              console.log("taxIDlength:: ", taxIDlength)
              console.log("taxID:: ", "'"+taxID+"'")
              console.log("btpID:: ", btpID)
              console.log("gSchemeID:: ", gSchemeID)
              
              if (docType === 1 || docType === 2) { // Tax Invoice OR ABB
                // A lot of input errors checking here ...
                // return res.json({ error: 'reason of error of docID:' + docID})
                // const ref = db.collection('/Companies/' + companyID + '/Docs').doc(objectID)
                var ISCTLI = [];
                var items = doc.items.filter((item)=> (item.Lbasis != "" && item.Ltax != "" && item.Ltotal != ""))
                console.log("items doctype 2 || doctype 3:::: ", items)
                
                for (var i = 0; i < items.length; i++) {
                  var item = items[i];
                  var tempData = {
                    "ADLD.LineID": String(i + 1),
                    "STP.ID": this.isEmpty(item.productID),
                    "STP.Name": this.isEmpty(item.description),
                    "STP.ITPI.ExpiryDateTime": "",
                    "SLTA.GPPTP.ChargeAmount": this.isEmptyNum(
                      item.price,
                      companyID,
                      doc.domain
                    ),
                    "SLTD.BilledQuantity.unitCode": this.isEmpty(item.unit),
                    "SLTD.BilledQuantity": this.isEmptyNum(item.quantity),
                    "SLTS.ATT.TypeCode": "VAT", // HARDCODE
                    "SLTS.ATT.CalculatedRate": this.isEmptyNum(item.Lvat),
                    "SLTS.ATT.BasisAmount": this.isEmptyNum(item.Lbasis),
                    "SLTS.ATT.CalculatedAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STAC.ChargeIndicator": false,
                    "SLTS.STAC.ActualAmount": this.isEmptyNum(
                      item.Ldiscount,
                      companyID,
                      doc.domain
                      ),
                    "SLTS.STAC.ReasonCode": "",
                    "SLTS.STAC.Reason": "",
                    "SLTS.STSLMS.TaxTotalAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STSLMS.NetLineTotalAmount": this.isEmptyNum(
                      item.Lbasis
                    ),
                    "SLTS.STSLMS.NetIncludingTaxesLineTotalAmount":
                      this.isEmptyNum(item.Ltotal),
                  };

                  ISCTLI.push(tempData);
                }

                var ard = [];

                if (doc.additionalRefDocs) {
                  for (var z = 0; z < doc.additionalRefDocs.length; z++) {
                    var ardItem = doc.additionalRefDocs[z];
                    ard.push({
                      IssuerAssignedID: this.isEmpty(
                        ardItem["issuerAssignedID"] == null
                          ? doc.baseRefNo
                          : ardItem["issuerAssignedID"]
                      ),
                      IssueDateTime: moment.utc(ardItem["issueDate"]).isValid()
                        ? moment
                            .utc(ardItem["issueDate"])
                            .format("YYYY-MM-DDTHH:mm:ss.SSS+07:00")
                        : "",
                      ReferenceTypeCode: this.isEmpty(
                        ardItem["typeCode"] == null
                          ? "338"
                          : ardItem["typeCode"]
                      ),
                    });
                  }
                }

                const sellerAddress = Splitter.split(doc.sellerAddress);
                var sellerZipCode = resolveZipCode(
                  doc.sellerAddress,
                  sellerAddress
                );
                const buyerAddress = Splitter.split(doc.buyerAddress);
                var buyerZipCode = resolveZipCode(
                  doc.buyerAddress,
                  buyerAddress
                );
                const cityCountryCode = this.getCityCountryCode(
                  sellerAddress.province,
                  sellerAddress.district,
                  sellerAddress.subdistrict
                );
                var index = doc.sellerAddress.search(" ");
                var sellerBuildingNumber = doc.sellerAddress
                  .substring(0, index)
                  .trim();
                if (
                  sellerBuildingNumber.search(" ") > -1 &&
                  sellerBuildingNumber.search(" ") < sellerBuildingNumber.length
                ) {
                  sellerBuildingNumber = sellerBuildingNumber.substring(
                    0,
                    sellerBuildingNumber.search(" ")
                  );
                }

                var edName = "";
                var typeNumber = "";
                if (docType === 1) {
                  edName = "ใบกำกับภาษี";
                  typeNumber = "388";
                } else if (docType === 2) {
                  edName = "ใบกำกับภาษีอย่างย่อ";
                  typeNumber = "T05";
                }

                const now = firebase.firestore.FieldValue.serverTimestamp();
                fireStoreData = {
                  objectID: objectID,
                  "@SellerBranchID": doc.sellerBranchID,
                  "@BuyerBranchID": doc.buyerBranchID,
                  "@BuyerEmail": this.isEmpty(doc.buyerEmail),
                  "@Keywords": "",
                  "@Errors": [],
                  "@DocType": parseInt(doc.docType),
                  "@SignerID": 1,
                  "@SignedPdfPath": "",
                  "@SignedXmlPath": "",
                  "@SignedXmlUrl": "",
                  "@SignedPdfUrl": "",
                  "@UnsignedPdfUrl": "",
                  "@TimeSignedXml": null,
                  "@TimeCreated": now,
                  "@TimeUpdated": now,
                  "@DownloadedXml": false,
                  "@SendEmailType": 0,
                  "@SendEmailDelay": 0,
                  "@DocData": docData,
                  "@DocPdfID": DocPdfID,
                  "ED.ID": String(doc.docID),
                  "ED.Name": edName,
                  "ED.TypeCode": typeNumber,
                  "ED.IssueDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.IssueDateTime.Timestamp": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.PurposeCode": "",
                  "ED.Purpose": "",
                  "ED.CreationDateTime": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.CreationDateTime.Timestamp": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.IN.Subject": this.isEmpty(doc.noteSubject),

                  "SCTT.AHTA.STP.Name": doc.sellerName,
                  "SCTT.AHTA.STP.GlobalID": "",
                  "SCTT.AHTA.STP.STR.ID": doc.sellerTaxID + doc.sellerBranchID,
                  "SCTT.AHTA.STP.STR.schemeID": "TXID",
                  "SCTT.AHTA.STP.PTA.PostcodeCode": this.isEmpty(sellerZipCode),
                  "SCTT.AHTA.STP.PTA.LineOne": this.isEmpty(doc.sellerAddress),
                  "SCTT.AHTA.STP.PTA.LineTwo": "",
                  "SCTT.AHTA.STP.PTA.LineThree": "",
                  "SCTT.AHTA.STP.PTA.LineFour": "",
                  "SCTT.AHTA.STP.PTA.LineFive": "",
                  "SCTT.AHTA.STP.PTA.StreetName": this.isEmpty(
                    sellerAddress ? sellerAddress.address : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.city : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.cityName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambon : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambonName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountryID": "TH",
                  "SCTT.AHTA.STP.PTA.CountryID.NameTH": "ประเทศไทย",
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID": this.isEmpty(
                    cityCountryCode ? cityCountryCode.county : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.countyName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.BuildingName": "", // TODOisEmpty(oadm.Building),
                  "SCTT.AHTA.STP.PTA.BuildingNumber":
                    this.isEmpty(sellerBuildingNumber),
                  "SCTT.AHTA.BORD.IssuerAssignedID": doc.buyerOrderRefDoc
                    ? this.isEmpty(doc.buyerOrderRefDoc["issuerAssignedID"])
                    : "",
                  "SCTT.AHTA.BORD.IssueDateTime": doc.buyerOrderRefDoc
                    ? moment(
                        doc.buyerOrderRefDoc["issueDate"],
                        "YYYY-MM-DD"
                      ).isValid()
                      ? moment(
                          doc.buyerOrderRefDoc["issueDate"],
                          "YYYY-MM-DD"
                        ).format("YYYY-MM-DDTHH:mm:ss.SSS+07:00")
                      : ""
                    : "",
                  "SCTT.AHTA.BORD.ReferenceTypeCode": doc.buyerOrderRefDoc
                    ? this.isEmpty(doc.buyerOrderRefDoc["typeCode"])
                    : "",
                  "SCTT.AHTA.BTP.ID": doc.buyerID,
                  "SCTT.AHTA.ARD": ard,
                  "SCTT.AHTA.BTP.GlobalID": "",
                  "SCTT.AHTA.BTP.Name": doc.buyerName,
                  "SCTT.AHTA.BTP.STR.ID": btpID,
                  "SCTT.AHTA.BTP.STR.schemeID": gSchemeID,
                  "SCTT.AHTA.BTP.PTA.PostcodeCode": this.isEmpty(buyerZipCode),
                  "SCTT.AHTA.BTP.PTA.LineOne": doc.buyerAddress,
                  "SCTT.AHTA.BTP.PTA.LineTwo": "",
                  "SCTT.AHTA.BTP.PTA.LineThree": "",
                  "SCTT.AHTA.BTP.PTA.LineFour": "",
                  "SCTT.AHTA.BTP.PTA.LineFive": "",
                  "SCTT.AHTA.BTP.PTA.CountryID": this.getForeignCountryCode(doc.domain),
                  "SCTT.AHTA.BTP.PTA.CountryID.NameTH": this.getForeignCountryNameTH(doc.domain),
                  "SCTT.AHTD.SFTP.ID": "",
                  "SCTT.AHTD.ADSC.OccurrenceDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "SCTT.AHTS.InvoiceCurrencyCode": doc.currency,
                  "SCTT.AHTS.ATT.TypeCode": "VAT", // Hardcode
                  "SCTT.AHTS.ATT.CalculatedRate": this.isEmptyNum(doc.vat),
                  "SCTT.AHTS.ATT.BasisAmount": this.isEmptyNum(doc.basis),
                  "SCTT.AHTS.ATT.CalculatedAmount": this.isEmptyNum(doc.tax),
                  // 'SCTT.AHTS.STAC': STAC,
                  "SCTT.AHTS.STSHMS.LineTotalAmount": this.isEmptyNum(doc.line),
                  "SCTT.AHTS.STSHMS.AllowanceTotalAmount": this.isEmptyNum(
                    doc.discount
                  ),
                  "SCTT.AHTS.STSHMS.TaxBasisTotalAmount": this.isEmptyNum(
                    doc.basis
                  ),
                  "SCTT.AHTS.STSHMS.TaxTotalAmount": this.isEmptyNum(doc.tax),
                  "SCTT.AHTS.STSHMS.GrandTotalAmount": this.isEmptyNum(
                    doc.total
                  ),
                  "SCTT.ISCTLI": ISCTLI,
                };

                // console.log(fireStoreData)
              } else if (docType === 3) {
                // A lot of input errors checking here ...
                // return res.json({ error: 'reason of error of docID:' + docID})

                // const ref = db.collection('/Companies/' + companyID + '/Docs').doc(objectID)
                ISCTLI = [];
                items = doc.items.filter((item)=> (item.Lbasis != "" && item.Ltax != "" && item.Ltotal != ""))
                console.log("items:::: ", items)

                for (i = 0; i < items.length; i++) {
                  item = items[i];
                  tempData = {
                    "ADLD.LineID": String(i + 1),
                    "STP.ID": this.isEmpty(item.productID),
                    "STP.Name": this.isEmpty(item.description),
                    "STP.ITPI.ExpiryDateTime": "",
                    "SLTA.GPPTP.ChargeAmount": this.isEmptyNum(
                      item.price,
                      companyID,
                      doc.domain
                    ),
                    "SLTD.BilledQuantity.unitCode": this.isEmpty(item.unit),
                    "SLTD.BilledQuantity": this.isEmptyNum(item.quantity),
                    "SLTS.ATT.TypeCode": "VAT", // HARDCODE
                    "SLTS.ATT.CalculatedRate": this.isEmptyNum(item.Lvat),
                    "SLTS.ATT.BasisAmount": this.isEmptyNum(item.Lbasis),
                    "SLTS.ATT.CalculatedAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STAC.ChargeIndicator": false,
                    "SLTS.STAC.ActualAmount": this.isEmptyNum(
                      item.Ldiscount,
                      companyID,
                      doc.domain
                      ),
                    "SLTS.STAC.ReasonCode": "",
                    "SLTS.STAC.Reason": "",
                    "SLTS.STSLMS.TaxTotalAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STSLMS.NetLineTotalAmount": this.isEmptyNum(
                      item.Lbasis
                    ),
                    "SLTS.STSLMS.NetIncludingTaxesLineTotalAmount":
                      this.isEmptyNum(item.Ltotal),
                  };

                  ISCTLI.push(tempData);
                }
                ard = [];

                if (doc.additionalRefDocs) {
                  for (z = 0; z < doc.additionalRefDocs.length; z++) {
                    ardItem = doc.additionalRefDocs[z];
                    ard.push({
                      IssuerAssignedID: this.isEmpty(
                        ardItem["issuerAssignedID"] == null
                          ? doc.baseRefNo
                          : ardItem["issuerAssignedID"]
                      ),
                      IssueDateTime: moment.utc(ardItem["issueDate"]).isValid()
                        ? moment
                            .utc(ardItem["issueDate"])
                            .format("YYYY-MM-DDTHH:mm:ss.SSS+07:00")
                        : "",
                      ReferenceTypeCode: this.isEmpty(
                        ardItem["typeCode"] == null
                          ? "388"
                          : ardItem["typeCode"]
                      ),
                    });
                  }
                }

                const sellerAddress = Splitter.split(doc.sellerAddress);
                sellerZipCode = resolveZipCode(doc.sellerAddress, sellerAddress);
                const buyerAddress = Splitter.split(doc.buyerAddress);
                buyerZipCode = resolveZipCode(doc.buyerAddress, buyerAddress);
                const cityCountryCode = this.getCityCountryCode(
                  sellerAddress.province,
                  sellerAddress.district,
                  sellerAddress.subdistrict
                );
                index = doc.sellerAddress.search(" ");
                sellerBuildingNumber = doc.sellerAddress
                  .substring(0, index)
                  .trim();
                if (
                  sellerBuildingNumber.search(" ") > -1 &&
                  sellerBuildingNumber.search(" ") < sellerBuildingNumber.length
                ) {
                  sellerBuildingNumber = sellerBuildingNumber.substring(
                    0,
                    sellerBuildingNumber.search(" ")
                  );
                }

                const now = firebase.firestore.FieldValue.serverTimestamp();
                fireStoreData = {
                  objectID: objectID,
                  "@SellerBranchID": doc.sellerBranchID,
                  "@BuyerBranchID": doc.buyerBranchID,
                  "@BuyerEmail": this.isEmpty(doc.buyerEmail),
                  "@Keywords": "",
                  "@Errors": [],
                  "@DocType": parseInt(doc.docType),
                  "@SignerID": 1,
                  "@SignedPdfPath": "",
                  "@SignedXmlPath": "",
                  "@SignedXmlUrl": "",
                  "@SignedPdfUrl": "",
                  "@UnsignedPdfUrl": "",
                  "@TimeSignedXml": null,
                  "@TimeCreated": now,
                  "@TimeUpdated": now,
                  "@DownloadedXml": false,
                  "@SendEmailType": 0,
                  "@SendEmailDelay": 0,
                  "@DocData": docData,
                  "@DocPdfID": DocPdfID,
                  "ED.ID": String(doc.docID),
                  "ED.Name": "ใบเพิ่มหนี้", // ใบลดหนี้
                  "ED.TypeCode": 80, // 80 = ใบเพิ่มหนี้ , 81 = ใบลดหนี้
                  "ED.IssueDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.IssueDateTime.Timestamp": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.PurposeCode": doc.purposeCode,
                  "ED.Purpose": doc.purpose,
                  "ED.CreationDateTime": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.CreationDateTime.Timestamp": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.IN.Subject": this.isEmpty(doc.noteSubject),

                  "SCTT.AHTA.STP.Name": doc.sellerName,
                  "SCTT.AHTA.STP.GlobalID": "",
                  "SCTT.AHTA.STP.STR.ID": doc.sellerTaxID + doc.sellerBranchID,
                  "SCTT.AHTA.STP.STR.schemeID": "TXID",
                  "SCTT.AHTA.STP.PTA.PostcodeCode": this.isEmpty(sellerZipCode),
                  "SCTT.AHTA.STP.PTA.LineOne": this.isEmpty(doc.sellerAddress),
                  "SCTT.AHTA.STP.PTA.LineTwo": "",
                  "SCTT.AHTA.STP.PTA.LineThree": "",
                  "SCTT.AHTA.STP.PTA.LineFour": "",
                  "SCTT.AHTA.STP.PTA.LineFive": "",
                  "SCTT.AHTA.STP.PTA.StreetName": this.isEmpty(
                    sellerAddress ? sellerAddress.address : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.city : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.cityName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambon : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambonName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountryID": "TH",
                  "SCTT.AHTA.STP.PTA.CountryID.NameTH": "ประเทศไทย",
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID": this.isEmpty(
                    cityCountryCode ? cityCountryCode.county : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.countyName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.BuildingName": "", // TODOthis.isEmpty(oadm.Building),
                  "SCTT.AHTA.STP.PTA.BuildingNumber":
                    this.isEmpty(sellerBuildingNumber),
                  "SCTT.AHTA.BTP.ID": doc.buyerID,
                  "SCTT.AHTA.ARD": ard,
                  "SCTT.AHTA.BTP.GlobalID": "",
                  "SCTT.AHTA.BTP.Name": doc.buyerName,
                  "SCTT.AHTA.BTP.STR.ID": btpID,
                  "SCTT.AHTA.BTP.STR.schemeID": gSchemeID,
                  "SCTT.AHTA.BTP.PTA.PostcodeCode": this.isEmpty(buyerZipCode),
                  "SCTT.AHTA.BTP.PTA.LineOne": doc.buyerAddress,
                  "SCTT.AHTA.BTP.PTA.LineTwo": "",
                  "SCTT.AHTA.BTP.PTA.LineThree": "",
                  "SCTT.AHTA.BTP.PTA.LineFour": "",
                  "SCTT.AHTA.BTP.PTA.LineFive": "",
                  "SCTT.AHTA.BTP.PTA.CountryID": this.getForeignCountryCode(doc.domain),
                  "SCTT.AHTA.BTP.PTA.CountryID.NameTH": this.getForeignCountryNameTH(doc.domain),
                  "SCTT.AHTD.SFTP.ID": "",
                  "SCTT.AHTD.ADSC.OccurrenceDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",

                  "SCTT.AHTS.InvoiceCurrencyCode": doc.currency,
                  "SCTT.AHTS.ATT.TypeCode": "VAT", // Hardcode
                  "SCTT.AHTS.ATT.CalculatedRate": this.isEmptyNum(doc.vat),
                  "SCTT.AHTS.ATT.BasisAmount": this.isEmptyNum(doc.basis),
                  "SCTT.AHTS.ATT.CalculatedAmount": this.isEmptyNum(doc.tax),
                  // 'SCTT.AHTS.STAC': STAC,

                  "SCTT.AHTS.STSHMS.OriginalInformationAmount": this.isEmptyNum(
                    doc.originalinformationamount
                  ),
                  "SCTT.AHTS.STSHMS.LineTotalAmount": this.isEmptyNum(doc.line),
                  "SCTT.AHTS.STSHMS.AllowanceTotalAmount": this.isEmptyNum(
                    doc.discount
                  ),
                  "SCTT.AHTS.STSHMS.DifferenceInformationAmount":
                    this.isEmptyNum(doc.differenceInformationAmount),
                  "SCTT.AHTS.STSHMS.TaxBasisTotalAmount": this.isEmptyNum(
                    doc.basis
                  ),
                  "SCTT.AHTS.STSHMS.TaxTotalAmount": this.isEmptyNum(doc.tax),
                  "SCTT.AHTS.STSHMS.GrandTotalAmount": this.isEmptyNum(
                    doc.total
                  ),

                  "SCTT.ISCTLI": ISCTLI,
                };

                console.log("fireStoreData 3:: ", fireStoreData);
              } else if (docType === 4) {
                // const ref = db.collection('/Companies/' + companyID + '/Docs').doc(objectID)
                ISCTLI = [];
                items = doc.items.filter((item)=> (item.Lbasis != "" && item.Ltax != "" && item.Ltotal != ""))


                console.log("items:::: doctype 4", items)
                for (i = 0; i < items.length; i++) {
                  item = items[i];
                  tempData = {
                    "ADLD.LineID": String(i + 1),
                    "STP.ID": this.isEmpty(item.productID),
                    "STP.Name": this.isEmpty(item.description),
                    "STP.ITPI.ExpiryDateTime": "",
                    "SLTA.GPPTP.ChargeAmount": this.isEmptyNum(
                      item.price,
                      companyID,
                      doc.domain
                    ),
                    "SLTD.BilledQuantity.unitCode": this.isEmpty(item.unit),
                    "SLTD.BilledQuantity": this.isEmptyNum(item.quantity),
                    "SLTS.ATT.TypeCode": "VAT", // HARDCODE
                    "SLTS.ATT.CalculatedRate": this.isEmptyNum(item.Lvat),
                    "SLTS.ATT.BasisAmount": this.isEmptyNum(item.Lbasis),
                    "SLTS.ATT.CalculatedAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STAC.ChargeIndicator": false,
                    "SLTS.STAC.ActualAmount": this.isEmptyNum(
                      item.Ldiscount,
                      companyID,
                      doc.domain
                      ),
                    "SLTS.STAC.ReasonCode": "",
                    "SLTS.STAC.Reason": "",
                    "SLTS.STSLMS.TaxTotalAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STSLMS.NetLineTotalAmount": this.isEmptyNum(
                      item.Lbasis
                    ),
                    "SLTS.STSLMS.NetIncludingTaxesLineTotalAmount":
                      this.isEmptyNum(item.Ltotal),
                  };

                  ISCTLI.push(tempData);
                }

                ard = [];
                const addedRefIds = new Set();

                if (doc.additionalRefDocs) {
                  for (z = 0; z < doc.additionalRefDocs.length; z++) {
                    ardItem = doc.additionalRefDocs[z];
                    const issuerAssignedID = this.isEmpty(
                      ardItem["issuerAssignedID"] == null
                        ? doc.baseRefNo
                        : ardItem["issuerAssignedID"]
                    );
                    
                    // ตรวจสอบว่า IssuerAssignedID นี้ถูกเพิ่มไปแล้วหรือยัง
                    if (!addedRefIds.has(issuerAssignedID)) {
                      addedRefIds.add(issuerAssignedID);
                      ard.push({
                        IssuerAssignedID: issuerAssignedID,
                        IssueDateTime: moment.utc(ardItem["issueDate"]).isValid()
                          ? moment
                              .utc(ardItem["issueDate"])
                              .format("YYYY-MM-DDTHH:mm:ss.SSS+07:00")
                          : "",
                        ReferenceTypeCode: this.isEmpty(
                          ardItem["typeCode"] == null
                            ? "388"
                            : ardItem["typeCode"]
                        ),
                      });
                    }
                  }
                }

                const sellerAddress = Splitter.split(doc.sellerAddress);
                sellerZipCode = resolveZipCode(doc.sellerAddress, sellerAddress);
                const buyerAddress = Splitter.split(doc.buyerAddress);
                buyerZipCode = resolveZipCode(doc.buyerAddress, buyerAddress);
                const cityCountryCode = this.getCityCountryCode(
                  sellerAddress.province,
                  sellerAddress.district,
                  sellerAddress.subdistrict
                );
                index = doc.sellerAddress.search(" ");
                sellerBuildingNumber = doc.sellerAddress
                  .substring(0, index)
                  .trim();
                if (
                  sellerBuildingNumber.search(" ") > -1 &&
                  sellerBuildingNumber.search(" ") < sellerBuildingNumber.length
                ) {
                  sellerBuildingNumber = sellerBuildingNumber.substring(
                    0,
                    sellerBuildingNumber.search(" ")
                  );
                }

                const now = firebase.firestore.FieldValue.serverTimestamp();
                fireStoreData = {
                  objectID: objectID,
                  "@SellerBranchID": doc.sellerBranchID,
                  "@BuyerBranchID": doc.buyerBranchID,
                  "@BuyerEmail": this.isEmpty(doc.buyerEmail),
                  "@Keywords": "",
                  "@Errors": [],
                  "@DocType": parseInt(doc.docType),
                  "@SignerID": 1,
                  "@SignedPdfPath": "",
                  "@SignedXmlPath": "",
                  "@SignedXmlUrl": "",
                  "@SignedPdfUrl": "",
                  "@UnsignedPdfUrl": "",
                  "@TimeSignedXml": null,
                  "@TimeCreated": now,
                  "@TimeUpdated": now,
                  "@DownloadedXml": false,
                  "@SendEmailType": 0,
                  "@SendEmailDelay": 0,
                  "@DocData": docData,
                  "@DocPdfID": DocPdfID,
                  "ED.ID": String(doc.docID),
                  "ED.Name": "ใบลดหนี้", // ใบลดหนี้
                  "ED.TypeCode": 81, // 80 = ใบเพิ่มหนี้ , 81 = ใบลดหนี้
                  "ED.IssueDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.IssueDateTime.Timestamp": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.PurposeCode": doc.purposeCode,
                  "ED.Purpose": doc.purpose,
                  "ED.CreationDateTime": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.CreationDateTime.Timestamp": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.IN.Subject": this.isEmpty(doc.noteSubject),

                  "SCTT.AHTA.STP.Name": doc.sellerName,
                  "SCTT.AHTA.STP.GlobalID": "",
                  "SCTT.AHTA.STP.STR.ID": doc.sellerTaxID + doc.sellerBranchID,
                  "SCTT.AHTA.STP.STR.schemeID": "TXID",
                  "SCTT.AHTA.STP.PTA.PostcodeCode": this.isEmpty(sellerZipCode),
                  "SCTT.AHTA.STP.PTA.LineOne": this.isEmpty(doc.sellerAddress),
                  "SCTT.AHTA.STP.PTA.LineTwo": "",
                  "SCTT.AHTA.STP.PTA.LineThree": "",
                  "SCTT.AHTA.STP.PTA.LineFour": "",
                  "SCTT.AHTA.STP.PTA.LineFive": "",
                  "SCTT.AHTA.STP.PTA.StreetName": this.isEmpty(
                    sellerAddress ? sellerAddress.address : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.city : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.cityName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambon : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambonName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountryID": "TH",
                  "SCTT.AHTA.STP.PTA.CountryID.NameTH": "ประเทศไทย",
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID": this.isEmpty(
                    cityCountryCode ? cityCountryCode.county : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.countyName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.BuildingName": "", // TODOthis.isEmpty(oadm.Building),
                  "SCTT.AHTA.STP.PTA.BuildingNumber":
                    this.isEmpty(sellerBuildingNumber),
                  "SCTT.AHTA.BTP.ID": doc.buyerID,
                  "SCTT.AHTA.ARD": ard,
                  "SCTT.AHTA.BTP.GlobalID": "",
                  "SCTT.AHTA.BTP.Name": doc.buyerName,
                  "SCTT.AHTA.BTP.STR.ID": btpID,
                  "SCTT.AHTA.BTP.STR.schemeID":gSchemeID,
                  "SCTT.AHTA.BTP.PTA.PostcodeCode": this.isEmpty(buyerZipCode),
                  "SCTT.AHTA.BTP.PTA.LineOne": doc.buyerAddress,
                  "SCTT.AHTA.BTP.PTA.LineTwo": "",
                  "SCTT.AHTA.BTP.PTA.LineThree": "",
                  "SCTT.AHTA.BTP.PTA.LineFour": "",
                  "SCTT.AHTA.BTP.PTA.LineFive": "",
                  "SCTT.AHTA.BTP.PTA.CountryID": this.getForeignCountryCode(doc.domain),
                  "SCTT.AHTA.BTP.PTA.CountryID.NameTH": this.getForeignCountryNameTH(doc.domain),
                  "SCTT.AHTD.SFTP.ID": "",
                  "SCTT.AHTD.ADSC.OccurrenceDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",

                  "SCTT.AHTS.InvoiceCurrencyCode": doc.currency,
                  "SCTT.AHTS.ATT.TypeCode": "VAT", // Hardcode
                  "SCTT.AHTS.ATT.CalculatedRate": this.isEmptyNum(doc.vat),
                  "SCTT.AHTS.ATT.BasisAmount": this.isEmptyNum(doc.basis),
                  "SCTT.AHTS.ATT.CalculatedAmount": this.isEmptyNum(doc.tax),

                  "SCTT.AHTS.STSHMS.OriginalInformationAmount": this.isEmptyNum(
                    doc.originalinformationamount
                  ),
                  "SCTT.AHTS.STSHMS.LineTotalAmount": this.isEmptyNum(doc.line),
                  "SCTT.AHTS.STSHMS.AllowanceTotalAmount": this.isEmptyNum(
                    doc.discount
                  ),
                  "SCTT.AHTS.STSHMS.DifferenceInformationAmount":
                    this.isEmptyNum(doc.differenceInformationAmount),
                  "SCTT.AHTS.STSHMS.TaxBasisTotalAmount": this.isEmptyNum(
                    doc.basis
                  ),
                  "SCTT.AHTS.STSHMS.TaxTotalAmount": this.isEmptyNum(doc.tax),
                  "SCTT.AHTS.STSHMS.GrandTotalAmount": this.isEmptyNum(
                    doc.total
                  ),

                  "SCTT.ISCTLI": ISCTLI,
                };

                console.log("fireStoreData:: ", fireStoreData);
              } else if (docType === 5 || docType === 6) {
                // const ref = db.collection('/Companies/' + companyID + '/Docs').doc(objectID)

                console.log("Doc Type : 6666");
                ISCTLI = [];
                items = doc.items.filter((item)=> (item.Lbasis != "" && item.Ltax != "" && item.Ltotal != ""))
                console.log("items:::: doctype 5 || 6", items)
                console.log("items:::: doctype 5 || 6 -- original:: ", doc.items)
                for (i = 0; i < items.length; i++) {
                  item = items[i];
                  tempData = {
                    "ADLD.LineID": String(i + 1),
                    "STP.ID": this.isEmpty(item.productID),
                    "STP.Name": this.isEmpty(item.description),
                    "STP.ITPI.ExpiryDateTime": "",
                    "SLTA.GPPTP.ChargeAmount": this.isEmptyNum(
                      item.price,
                      companyID,
                      doc.domain
                    ),
                    "SLTD.BilledQuantity.unitCode": this.isEmpty(item.unit),
                    "SLTD.BilledQuantity": this.isEmptyNum(item.quantity),
                    "SLTS.ATT.TypeCode": "VAT", // HARDCODE
                    "SLTS.ATT.CalculatedRate": this.isEmptyNum(item.Lvat),
                    "SLTS.ATT.BasisAmount": this.isEmptyNum(item.Lbasis),
                    "SLTS.ATT.CalculatedAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STAC.ChargeIndicator": false,
                    "SLTS.STAC.ActualAmount": this.isEmptyNum(
                      item.Ldiscount,
                      companyID,
                      doc.domain
                      ),
                    "SLTS.STAC.ReasonCode": "",
                    "SLTS.STAC.Reason": "",
                    "SLTS.STSLMS.TaxTotalAmount": this.isEmptyNum(item.Ltax),
                    "SLTS.STSLMS.NetLineTotalAmount": this.isEmptyNum(
                      item.Lbasis
                    ),
                    "SLTS.STSLMS.NetIncludingTaxesLineTotalAmount":
                      this.isEmptyNum(item.Ltotal),
                  };

                  ISCTLI.push(tempData);
                }
                ard = [];

                if (doc.additionalRefDocs) {
                  for (z = 0; z < doc.additionalRefDocs.length; z++) {
                    ardItem = doc.additionalRefDocs[z];
                    ard.push({
                      IssuerAssignedID: this.isEmpty(
                        ardItem["issuerAssignedID"] == null
                          ? doc.baseRefNo
                          : ardItem["issuerAssignedID"]
                      ),
                      IssueDateTime: moment.utc(ardItem["issueDate"]).isValid()
                        ? moment
                            .utc(ardItem["issueDate"])
                            .format("YYYY-MM-DDTHH:mm:ss.SSS+07:00")
                        : "",
                      ReferenceTypeCode: this.isEmpty(
                        ardItem["typeCode"] == null
                          ? "388"
                          : ardItem["typeCode"]
                      ),
                    });
                  }
                }

                const sellerAddress = Splitter.split(doc.sellerAddress);
                sellerZipCode = resolveZipCode(doc.sellerAddress, sellerAddress);
                const buyerAddress = Splitter.split(doc.buyerAddress);
                buyerZipCode = resolveZipCode(doc.buyerAddress, buyerAddress);
                var cityCountryCode = {};
                if (sellerAddress) {
                  cityCountryCode = this.getCityCountryCode(
                    sellerAddress.province,
                    sellerAddress.district,
                    sellerAddress.subdistrict
                  );
                } else {
                  cityCountryCode = {
                    county: "",
                    countyName: "",
                    city: "",
                    cityName: "",
                    tambon: "",
                    tambonName: "",
                  };
                }
                index = doc.sellerAddress.search(" ");
                sellerBuildingNumber = doc.sellerAddress
                  .substring(0, index)
                  .trim();
                if (
                  sellerBuildingNumber.search(" ") > -1 &&
                  sellerBuildingNumber.search(" ") < sellerBuildingNumber.length
                ) {
                  sellerBuildingNumber = sellerBuildingNumber.substring(
                    0,
                    sellerBuildingNumber.search(" ")
                  );
                }

                edName = "";
                var typeName = "";
                if (docType === 5) {
                  edName = "ใบรับ";
                  typeName = "T01";
                } else if (docType === 6) {
                  edName = "ใบเสร็จรับเงิน/ใบกำกับภาษี";
                  typeName = "T03";
                }
                const now = firebase.firestore.FieldValue.serverTimestamp();
                fireStoreData = {
                  objectID: objectID,
                  "@SellerBranchID": this.isEmpty(doc.sellerBranchID),
                  "@BuyerBranchID": this.isEmpty(doc.buyerBranchID),
                  "@BuyerEmail": this.isEmpty(doc.buyerEmail),
                  "@Keywords": "",
                  "@Errors": [],
                  "@DocType": parseInt(doc.docType),
                  "@SignerID": 1,
                  "@SignedPdfPath": "",
                  "@SignedXmlPath": "",
                  "@SignedXmlUrl": "",
                  "@SignedPdfUrl": "",
                  "@UnsignedPdfUrl": "",
                  "@TimeSignedXml": null,
                  "@TimeCreated": now,
                  "@TimeUpdated": now,
                  "@DownloadedXml": false,
                  "@SendEmailType": 0,
                  "@SendEmailDelay": 0,
                  "@DocData": docData,
                  "@DocPdfID": DocPdfID,
                  "ED.ID": String(doc.docID),
                  "ED.Name": edName,
                  "ED.TypeCode": typeName,
                  "ED.IssueDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.IssueDateTime.Timestamp": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.PurposeCode": "",
                  "ED.Purpose": "",
                  "ED.CreationDateTime": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "ED.CreationDateTime.Timestamp": moment(
                    doc.creationDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.creationDate, "YYYY-MM-DD").toDate()
                    : "",
                  "ED.IN.Subject": this.isEmpty(doc.noteSubject),

                  "SCTT.AHTA.STP.Name": doc.sellerName,
                  "SCTT.AHTA.STP.GlobalID": "",
                  "SCTT.AHTA.STP.STR.ID": doc.sellerTaxID + doc.sellerBranchID,
                  "SCTT.AHTA.STP.STR.schemeID": "TXID",
                  "SCTT.AHTA.STP.PTA.PostcodeCode": this.isEmpty(sellerZipCode),
                  "SCTT.AHTA.STP.PTA.LineOne": this.isEmpty(doc.sellerAddress),
                  "SCTT.AHTA.STP.PTA.LineTwo": "",
                  "SCTT.AHTA.STP.PTA.LineThree": "",
                  "SCTT.AHTA.STP.PTA.LineFour": "",
                  "SCTT.AHTA.STP.PTA.LineFive": "",
                  "SCTT.AHTA.STP.PTA.StreetName": this.isEmpty(
                    sellerAddress ? sellerAddress.address : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.city : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CityName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.cityName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambon : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CitySubDivisionName.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.tambonName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountryID": "TH",
                  "SCTT.AHTA.STP.PTA.CountryID.NameTH": "ประเทศไทย",
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID": this.isEmpty(
                    cityCountryCode ? cityCountryCode.county : ""
                  ),
                  "SCTT.AHTA.STP.PTA.CountrySubDivisionID.NameTH": this.isEmpty(
                    cityCountryCode ? cityCountryCode.countyName : ""
                  ),
                  "SCTT.AHTA.STP.PTA.BuildingName": "", // TODOthis.isEmpty(oadm.Building),
                  "SCTT.AHTA.STP.PTA.BuildingNumber":
                    this.isEmpty(sellerBuildingNumber),
                  "SCTT.AHTA.BTP.ID": doc.buyerID,
                  "SCTT.AHTA.ARD": ard,
                  "SCTT.AHTA.BTP.GlobalID": "",
                  "SCTT.AHTA.BTP.Name": doc.buyerName,
                  "SCTT.AHTA.BTP.STR.ID": btpID,
                  "SCTT.AHTA.BTP.STR.schemeID":  gSchemeID,
                  "SCTT.AHTA.BTP.PTA.PostcodeCode": this.isEmpty(buyerZipCode),
                  "SCTT.AHTA.BTP.PTA.LineOne": doc.buyerAddress,
                  "SCTT.AHTA.BTP.PTA.LineTwo": "",
                  "SCTT.AHTA.BTP.PTA.LineThree": "",
                  "SCTT.AHTA.BTP.PTA.LineFour": "",
                  "SCTT.AHTA.BTP.PTA.LineFive": "",
                  "SCTT.AHTA.BTP.PTA.CountryID": this.getForeignCountryCode(doc.domain),
                  "SCTT.AHTA.BTP.PTA.CountryID.NameTH": this.getForeignCountryNameTH(doc.domain),
                  "SCTT.AHTD.SFTP.ID": "",
                  "SCTT.AHTD.ADSC.OccurrenceDateTime": moment(
                    doc.issueDate,
                    "YYYY-MM-DD"
                  ).isValid()
                    ? moment(doc.issueDate, "YYYY-MM-DD").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS+07:00"
                      )
                    : "",
                  "SCTT.AHTS.InvoiceCurrencyCode": doc.currency,
                  "SCTT.AHTS.ATT.TypeCode": "VAT", // Hardcode
                  "SCTT.AHTS.ATT.CalculatedRate": this.isEmptyNum(doc.vat),
                  "SCTT.AHTS.ATT.BasisAmount": this.isEmptyNum(doc.basis),
                  "SCTT.AHTS.ATT.CalculatedAmount": this.isEmptyNum(doc.tax),

                  "SCTT.AHTS.STSHMS.LineTotalAmount": this.isEmptyNum(doc.line),
                  "SCTT.AHTS.STSHMS.AllowanceTotalAmount": this.isEmptyNum(
                    doc.discount
                  ),
                  "SCTT.AHTS.STSHMS.TaxBasisTotalAmount": this.isEmptyNum(
                    doc.basis
                  ),
                  "SCTT.AHTS.STSHMS.TaxTotalAmount": this.isEmptyNum(doc.tax),
                  "SCTT.AHTS.STSHMS.GrandTotalAmount": this.isEmptyNum(
                    doc.total
                  ),

                  "SCTT.ISCTLI": ISCTLI,
                };
              }

              console.log("fireStoreData 2:: ", fireStoreData);

                console.log("Docs : " + k);
                var path = "/Companies/" + companyID + "/Docs";
                console.log(path);
                const ref = fc.db.collection(path).doc(objectID);
                batch.set(ref, fireStoreData);

                // Queue as pending — NOT counted as success yet. Success is
                // only confirmed once the batch is committed to Firestore.
                pendingRecords.push({
                  row: k + 2, // +2 because row 1 is header, and k is 0-indexed
                  docID: doc.docID
                });

                // Commit in chunks (Firestore batch limit is 500 ops).
                if (k > 0 && k % 500 == 0) {
                  try {
                    console.log("Commit");
                    await batch.commit();
                    // Commit OK: promote this chunk's pending docs to success.
                    importLog.successCount += pendingRecords.length;
                    importLog.successRecords.push(...pendingRecords);
                    pendingRecords = [];
                    batch = fc.db.batch();
                  } catch (e) {
                    console.log(e);
                    // Commit failed: every pending doc in this chunk failed.
                    importLog.failureCount += pendingRecords.length;
                    for (const rec of pendingRecords) {
                      const batchErrorInfo = {
                        row: rec.row,
                        docID: rec.docID || 'unknown',
                        error: 'Batch commit error: ' + e.message
                      };
                      importLog.failedRecords.push(batchErrorInfo);
                      importLog.errors.push(batchErrorInfo);
                    }
                    pendingRecords = [];
                    batch = fc.db.batch();
                  }
                }

              } catch (docError) {
                // Track failed document
                importLog.failureCount++;

                // Enhanced error reporting
                let errorDetail = docError.message || 'เกิดข้อผิดพลาดไม่ทราบสาเหตุ';
                let errorType = 'UNKNOWN_ERROR';
                let suggestion = '';

                // Categorize error types and provide suggestions
                if (docError.message?.includes('เลขที่เอกสาร')) {
                  errorType = 'VALIDATION_ERROR';
                  suggestion = 'กรุณาตรวจสอบว่าคอลัมน์ "docID" มีค่าและไม่เป็นค่าว่าง';
                } else if (docError.message?.includes('docType')) {
                  errorType = 'INVALID_DOCTYPE';
                  suggestion = 'ประเภทเอกสาร (docType) ต้องเป็น 1-6 เท่านั้น';
                } else if (docError.message?.includes('items')) {
                  errorType = 'ITEM_ERROR';
                  suggestion = 'กรุณาตรวจสอบรายการสินค้า (items) ให้มีข้อมูล Lbasis, Ltax, Ltotal ครบถ้วน';
                } else if (docError.message?.includes('date') || docError.message?.includes('Date')) {
                  errorType = 'DATE_FORMAT_ERROR';
                  suggestion = 'รูปแบบวันที่ต้องเป็น YYYY-MM-DD (เช่น 2025-01-15)';
                } else if (docError.message?.includes('Tax') || docError.message?.includes('tax')) {
                  errorType = 'TAX_ID_ERROR';
                  suggestion = 'กรุณาตรวจสอบเลขประจำตัวผู้เสียภาษี (Tax ID) และรหัสสาขา';
                } else if (docError.message?.includes('address') || docError.message?.includes('Address')) {
                  errorType = 'ADDRESS_ERROR';
                  suggestion = 'กรุณาตรวจสอบที่อยู่ให้ครบถ้วนและถูกต้อง';
                } else if (docError.message?.includes('cannot read') || docError.message?.includes('undefined')) {
                  errorType = 'MISSING_FIELD';
                  suggestion = 'มีฟิลด์ข้อมูลที่จำเป็นหายไป กรุณาตรวจสอบความครบถ้วนของข้อมูล';
                }

                const errorInfo = {
                  row: k + 2, // +2 because row 1 is header, and k is 0-indexed
                  docID: doc?.docID || 'ไม่ระบุ',
                  docType: doc?.docType || 'ไม่ระบุ',
                  errorType: errorType,
                  error: errorDetail,
                  suggestion: suggestion,
                  // Additional context for debugging
                  buyerName: doc?.buyerName || 'ไม่ระบุ',
                  sellerName: doc?.sellerName || 'ไม่ระบุ',
                  issueDate: doc?.issueDate || 'ไม่ระบุ',
                  total: doc?.total || 'ไม่ระบุ'
                };

                importLog.failedRecords.push(errorInfo);
                importLog.errors.push(errorInfo);
                console.error(`❌ Failed to process document at row ${errorInfo.row}:`);
                console.error(`   📄 เอกสารเลขที่: ${errorInfo.docID}`);
                console.error(`   📋 ประเภท: ${errorInfo.docType}`);
                console.error(`   ⚠️  ประเภท Error: ${errorInfo.errorType}`);
                console.error(`   💬 รายละเอียด: ${errorInfo.error}`);
                console.error(`   💡 คำแนะนำ: ${errorInfo.suggestion}`);
                console.error(`   🔍 ข้อมูลเพิ่มเติม:`, {
                  buyerName: errorInfo.buyerName,
                  sellerName: errorInfo.sellerName,
                  issueDate: errorInfo.issueDate,
                  total: errorInfo.total
                });
              }
            }

            try {
              console.log("Commit");
              await batch.commit();
              // Final commit OK: promote any remaining pending docs to success.
              importLog.successCount += pendingRecords.length;
              importLog.successRecords.push(...pendingRecords);
              pendingRecords = [];
            } catch (e) {
              console.log(e);
              // Final commit failed: every remaining pending doc failed.
              // (This is the case that used to wrongly report "Success 14/14".)
              importLog.failureCount += pendingRecords.length;
              for (const rec of pendingRecords) {
                const finalErrorInfo = {
                  row: rec.row,
                  docID: rec.docID || 'unknown',
                  error: 'Final batch commit error: ' + e.message
                };
                importLog.failedRecords.push(finalErrorInfo);
                importLog.errors.push(finalErrorInfo);
              }
              pendingRecords = [];
            }
            
            // Log summary
            console.log("📊 Import Summary:");
            console.log(`✅ Success: ${importLog.successCount}/${importLog.totalRecords}`);
            console.log(`❌ Failed: ${importLog.failureCount}/${importLog.totalRecords}`);
            if (importLog.failedRecords.length > 0) {
              console.log("📋 Failed Records:", importLog.failedRecords);
            }
            
            // Return import log for the component to use
            return importLog;
          }
        }).catch(error=>{
          console.log('ERROR :',error)
          throw error;
        })
    }
  },
  modules: {},
};


